module.exports = __webpack_public_path__ + "img/calendar.b38f00a2.svg";